import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  wrapper: {
    alignSelf: 'center',
    alignItems: 'center',
  },
  link: {
    fontWeight: '700',
    color: '#00A0F3',
    textDecorationLine: 'underline',
  },
  title: {
    fontFamily: 'Inter',
    fontSize: 28,
    fontWeight: '700',
    textAlign: 'center',
  },
  message: {
    fontFamily: 'Inter',
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 26,
    textAlign: 'center',
    marginTop: 35,
  },
  button: {
    width: 350,
    alignSelf: 'center',
    marginTop: 35,
  },
})
